import { rootRef } from './firebase';

export type AuditAction =
  | 'season_lock.update'
  | 'member.disable'
  | 'member.enable'
  | 'member.delete'
  | 'member.create'
  | 'calibration.save'
  | 'quarter.confirm'
  | 'quarter.unlock'
  | 'peer.submit'
  | 'task.status'
  | 'login'
  | 'settings.registration';

export type AuditEntry = {
  action: AuditAction;
  actorId?: string;
  actorName?: string;
  targetId?: string;
  targetName?: string;
  evalYear?: number;
  detail?: string;
  meta?: Record<string, unknown>;
  at: number;
};

/** HR/시스템 중요 변경 감사 로그 (쓰기 실패해도 본 작업은 막지 않음) */
export async function writeAuditLog(entry: Omit<AuditEntry, 'at'> & { at?: number }): Promise<void> {
  const payload: AuditEntry = {
    ...entry,
    at: entry.at ?? Date.now(),
  };
  try {
    await rootRef().collection('audit_logs').add(payload);
  } catch (err) {
    console.error('[AUDIT] write failed:', err);
  }
}
